import { useEffect } from "react";
import * as THREE from "three";
import { captureCameraHome } from "../../runtime/cameraHome";

export function useAutoFitCameraOnMeshLoad({ autoFitCameraRef, cameraRef, controlsRef, sceneRef }) {
  useEffect(() => {
    const handleMeshLoaded = () => {
      if (!autoFitCameraRef.current) return;
      autoFitCameraRef.current = false;
      try {
        const camera = cameraRef.current;
        const controls = controlsRef.current;
        const scene = sceneRef.current;
        if (!camera || !controls || !scene) return;
        const modelGroup = scene.getObjectByName("modelGroup");
        if (!modelGroup) return;
        const bbox = new THREE.Box3().setFromObject(modelGroup);
        if (bbox.isEmpty()) return;
        const center = new THREE.Vector3();
        const size = new THREE.Vector3();
        bbox.getCenter(center);
        bbox.getSize(size);
        const maxDim = Math.max(size.x, size.y, size.z);
        if (maxDim <= 0) return;
        const fov = camera.fov * (Math.PI / 180);
        const dist = (maxDim / 2 / Math.tan(fov / 2)) * 1.8;
        const dir = new THREE.Vector3(0.6, 0.5, 1).normalize();
        camera.position.copy(center).addScaledVector(dir, dist);
        camera.lookAt(center);
        controls.target.copy(center);
        controls.update();
        captureCameraHome();
      } catch {
        /* ignore */
      }
    };
    window.addEventListener("mesh-loaded-to-scene", handleMeshLoaded);
    return () => window.removeEventListener("mesh-loaded-to-scene", handleMeshLoaded);
  }, [autoFitCameraRef, cameraRef, controlsRef, sceneRef]);
}
